import React, { Component, Fragment } from "react";
import { Link, Button } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import CheckoutHeader from "./include/CheckoutHeader";
import CheckoutForm from "./include/CheckoutForm";
import Testimonial from "./include/Testimonial";
import Faq from "./include/Faq";
import OrderDetails from "./include/OrderDetails";
import Timer from "./include/Timer";

export class Checkout extends Component {
	
	state = { 
        mobileButtonVisible: false,				 
	};
	
	componentDidMount() {		
		window.addEventListener('scroll', (e) => this.onScroll(e), true);		
	}
	  
	componentWillUnmount() {		
		window.removeEventListener('scroll', (e) => this.onScroll(e), true);
	}
	
	onScroll = e => {
		// only work for mobile
		if(this.context.state.isMobile())
		{
			let element = e.target
			// console.log(element.scrollHeight - element.scrollTop, element.clientHeight);
			if (element.scrollHeight - element.scrollTop < 1700) {
				// do something at end of scroll
				this.setState({ mobileButtonVisible: true });
			}
			else{
				this.setState({ mobileButtonVisible: false });
			}
		}	
	};
	
	
	render() {
		return (
		    <Fragment>
			    <div className="checkout-wrapper">
		            <CheckoutHeader></CheckoutHeader>
                    <section className="checkout">
				        <div className="container position-relative">
				    	    <Timer></Timer>
				    	    <div className="row main-row">
				    	        <div className="col-lg-7 first-col">
				    	    	    <h3 className="mb-4">Included with membership:</h3>
				    	    		<div className="membership d-flex align-items-center justify-content-between">
				    	    		    <div>
				    	    			    <img className=" d-block mx-auto" src="/images/membership-1.svg" alt="jobs board"/>
				    	    				<small className="mt-3 d-block text-center">Jobs Board</small>
				    	    			</div>
				    	    			<div>
				    					    <img className=" d-block mx-auto" src="/images/membership-4.svg" alt="Private Community"/>
				    	    			    <small className="mt-3 d-block text-center">Private Community</small>
				    	    			</div>
				    	    			<div>
				    	    			    <img className=" d-block mx-auto" src="/images/membership-3.svg" alt="Skills Courses"/>
				    	    				<small className="mt-3 d-block text-center">Skills Courses</small>
				    	    			</div>
				    	    			<div>
				    	    			    <img className=" d-block mx-auto" src="/images/membership-2.svg" alt="Portfolio"/>
				    	    				<small className="mt-3 d-block text-center">Portfolio</small>
				    	    			</div>
				    	    		</div>
				    				<h3 className="my-4 d-md-none d-block">Your order</h3>
				    				<OrderDetails clssName="d-md-none d-block"></OrderDetails>
				    				<CheckoutForm mobileButtonVisible={this.state.mobileButtonVisible}></CheckoutForm>
				    			</div>
				    	    	<div className="col-lg-5 second-col">
				    			    <div className="right-side">
				    				    <h3 className="mb-4 d-md-block d-none">Your order</h3>
				    					<OrderDetails clssName="d-md-block d-none"></OrderDetails>
				    					<h3 className="mt-5 mb-4">Frequently asked questions</h3>
				    					<Faq></Faq>	
				    					<h3 className="mt-5 mb-4">What Our Members Are Saying</h3>
				    					<div className="testimonial">
				    					    <Testimonial image="PiperGourley.png" name="Piper Gourley" title="" text="Dusten and Dave are some of the most trustworthy, reliable, and resourceful people in the freelancing industry. ProWriter helped me develop a clearer grasp on the realities of the freelancing market. I feel more prepared than many peers at my level to take on the work of recruiting clients and writing to various niches."></Testimonial>
				    					    <Testimonial image="JessicaLakritz.png" name="Jessica Lakritz" title="" text="My skills as a writer have significantly improved thanks to ProWriter. It’s helped me to write clearly and concisely about pretty much anything. Plus, I’ve also learned SEO skills which have helped me to get my dream clients!"></Testimonial>
											<Testimonial image="KasyLong.png" name="Kasy Long" title="" text="Since becoming a ProWriter Member, I have started writing entertainment articles for the popular website Screen Rant (through Valnet, Inc.). In addition, I have written education-based content for Study.com, one of the largest online learning platforms."></Testimonial>
				    					</div>
				    				</div>
				    	    	</div>
				    	    </div>
				    	</div>		
				    </section>
				</div>	
			</Fragment>
        );        
    };
}
Checkout.contextType = AppContext;
export default Checkout;


// WEBPACK FOOTER //
// ./src/components/general/Checkout.js